import { Button, message, type ButtonProps } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

interface CopyIdButtonProps extends Omit<ButtonProps, 'onClick'> {
  id: string;
}

export function CopyIdButton({ id, ...buttonProps }: CopyIdButtonProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(id);
    message.success('Identifiant copié');
  };

  return (
    <Button icon={<CopyOutlined />} onClick={handleCopy} size="small" {...buttonProps}>
      Copier l'ID
    </Button>
  );
}
